export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7132.528373d6.jpg";